export enum TrackingFrom {
  SIDEBAR_MENU = 'Sidebar Menu',
  SIDEBAR_MENU_DROPDOWN = 'Sidebar Menu Dropdown'
}
